import { FC, SVGAttributes } from 'react';

const Calendar: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M12.501 12.501C12.501 12.2248 12.7248 12.001 13.001 12.001H14.001C14.2771 12.001 14.501 12.2248 14.501 12.501V13.501C14.501 13.7771 14.2771 14.001 14.001 14.001H13.001C12.7248 14.001 12.501 13.7771 12.501 13.501V12.501Z"
        fill="currentColor"
      />
      <path
        d="M13.001 9.00098C12.7248 9.00098 12.501 9.22483 12.501 9.50098V10.501C12.501 10.7771 12.7248 11.001 13.001 11.001H14.001C14.2771 11.001 14.501 10.7771 14.501 10.501V9.50098C14.501 9.22483 14.2771 9.00098 14.001 9.00098H13.001Z"
        fill="currentColor"
      />
      <path
        d="M9.50098 12.501C9.50098 12.2248 9.72483 12.001 10.001 12.001H11.001C11.2771 12.001 11.501 12.2248 11.501 12.501V13.501C11.501 13.7771 11.2771 14.001 11.001 14.001H10.001C9.72483 14.001 9.50098 13.7771 9.50098 13.501V12.501Z"
        fill="currentColor"
      />
      <path
        d="M10.001 9.00098C9.72483 9.00098 9.50098 9.22483 9.50098 9.50098V10.501C9.50098 10.7771 9.72483 11.001 10.001 11.001H11.001C11.2771 11.001 11.501 10.7771 11.501 10.501V9.50098C11.501 9.22483 11.2771 9.00098 11.001 9.00098H10.001Z"
        fill="currentColor"
      />
      <path
        d="M15.501 9.50098C15.501 9.22483 15.7248 9.00098 16.001 9.00098H17.001C17.2771 9.00098 17.501 9.22483 17.501 9.50098V10.501C17.501 10.7771 17.2771 11.001 17.001 11.001H16.001C15.7248 11.001 15.501 10.7771 15.501 10.501V9.50098Z"
        fill="currentColor"
      />
      <path
        d="M16.001 12.001C15.7248 12.001 15.501 12.2248 15.501 12.501V13.501C15.501 13.7771 15.7248 14.001 16.001 14.001H17.001C17.2771 14.001 17.501 13.7771 17.501 13.501V12.501C17.501 12.2248 17.2771 12.001 17.001 12.001H16.001Z"
        fill="currentColor"
      />
      <path
        d="M6.50098 12.501C6.50098 12.2248 6.72483 12.001 7.00098 12.001H8.00098C8.27712 12.001 8.50098 12.2248 8.50098 12.501V13.501C8.50098 13.7771 8.27712 14.001 8.00098 14.001H7.00098C6.72483 14.001 6.50098 13.7771 6.50098 13.501V12.501Z"
        fill="currentColor"
      />
      <path
        d="M13.001 15.001C12.7248 15.001 12.501 15.2248 12.501 15.501V16.501C12.501 16.7771 12.7248 17.001 13.001 17.001H14.001C14.2771 17.001 14.501 16.7771 14.501 16.501V15.501C14.501 15.2248 14.2771 15.001 14.001 15.001H13.001Z"
        fill="currentColor"
      />
      <path
        d="M9.50098 15.501C9.50098 15.2248 9.72483 15.001 10.001 15.001H11.001C11.2771 15.001 11.501 15.2248 11.501 15.501V16.501C11.501 16.7771 11.2771 17.001 11.001 17.001H10.001C9.72483 17.001 9.50098 16.7771 9.50098 16.501V15.501Z"
        fill="currentColor"
      />
      <path
        d="M7.00098 15.001C6.72483 15.001 6.50098 15.2248 6.50098 15.501V16.501C6.50098 16.7771 6.72483 17.001 7.00098 17.001H8.00098C8.27712 17.001 8.50098 16.7771 8.50098 16.501V15.501C8.50098 15.2248 8.27712 15.001 8.00098 15.001H7.00098Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0004 2.10059C16.4974 2.10059 16.9004 2.50353 16.9004 3.00059V4.10059H18.0006C19.6022 4.10059 20.9006 5.39896 20.9006 7.00059V18.0006C20.9006 19.6022 19.6022 20.9006 18.0006 20.9006H6.00059C4.39896 20.9006 3.10059 19.6022 3.10059 18.0006V7.00059C3.10059 5.39896 4.39896 4.10059 6.00059 4.10059H7.10039L7.10039 3.00059C7.10039 2.50353 7.50333 2.10059 8.00039 2.10059C8.49745 2.10059 8.90039 2.50353 8.90039 3.00059V4.10059H15.1004V3.00059C15.1004 2.50353 15.5033 2.10059 16.0004 2.10059ZM5.00098 8.00098C5.00098 7.44869 5.44869 7.00098 6.00098 7.00098H18.001C18.5533 7.00098 19.001 7.44869 19.001 8.00098V18.001C19.001 18.5533 18.5533 19.001 18.001 19.001H6.00098C5.44869 19.001 5.00098 18.5533 5.00098 18.001V8.00098Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Calendar;
